import { combineReducers } from 'redux'

import createByIdReducer from '../entity/byId'
import createAllIdsReducer from '../entity/allIds'
import createIndexIdsReducer from '../entity/indexIds'
import createMetaReducer from '../entity/meta'

import { Task } from '../../features/tasks/types'

export default combineReducers({
  byId: createByIdReducer('task'),
  allIds: createAllIdsReducer('task'),
  indexIds: createIndexIdsReducer('task'),
  meta: createMetaReducer('task'),
})

interface Meta {
  taskTypes: Map<string, string> // TODO-TS -- not sure what this type should be
  total: number
}

interface State {
  byId: Map<string, Task>
  allIds: string[]
  indexIds: string[]
  meta: Meta
}

//Selectors

export const selectAllTasks = (state: State) => {
  return state.allIds.map((id) => state.byId[id]) || []
}

export const selectTask = (state: State, id: string) => {
  return state.byId[id] || {}
}

export const selectTaskIndex = (state: State) => {
  return state.indexIds.map((id) => state.byId[id]) || []
}

export const selectTaskMeta = (state: State) => {
  return state.meta || {}
}

export const selectTaskTypes = (state: State) => {
  return state.meta.taskTypes || {}
}
